<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">活动运营</h3>
      <Row class="row" >
        <Col span="2"><font style="color: #ed4014;">*</font>排序</Col>
        <Col span="4"><font style="color: #ed4014;">*</font>标签名</Col>
        <Col span="6"><font style="color: #ed4014;">*</font>描述</Col>
        <Col span="4"><font style="color: #ed4014;">*</font>标签图片</Col>
        <Col span="4">链接</Col>
        <Col span="2">高亮</Col>
        <Col span="2">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="2">
          <Input class="width30"  v-model="item.labelOrder" />
        </Col>
        <Col span="4">
          <Input class="width50" v-model="item.labelName"/>
        </Col>
        <Col span="6">
          <Input class="width120" v-model="item.remark"/>
        </Col>
        <Col span="4">
          <a @click.stop="uploadImg(item)" class="width30">配置</a>
        </Col>
        <Col span="4">
          <Input class="width80" v-model="item.link"/>
        </Col>
        <Col span="2">
          <Checkbox  v-model="item.isSelect" class="width30"></Checkbox>
        </Col>
        <Col span="2">
          <a @click.stop="deleteItem(item,index)" class="width30">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
      <img-upload :n="uploadN" :fid="configFid" :orderId="orderId" @pic="pic" :pics="pics" :num="1" :maxnum="1"></img-upload>
      <!--<div slot="footer"></div>-->
    </Modal>
  </div>

</template>

<script>
  // import {labelgetConfigImg} from "../../../../api/projectConfig";
  import ImgUpload from './ImgUpload'
  import {labellist,labeledit,labelremove} from "../../../../api/projectConfig";
  import {isType} from "../../../../utils/public";

  export default {
    name: "ActivityConfig",
    components:{
      ImgUpload
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.labellist()
        this.isShow=true
      },
      // fid(){
      //   this.labellist()
      // }
    },
    data(){
      return {
        uploadN:0,
        isShow:false,
        data:[],
        loading:true,
        orderId:0,
        configFid:'',
        pics:[]
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        let order=1
        if(this.data.length > 0){
          order = this.data[this.data.length-1].labelOrder;
          if((+order).toString()==='NaN' || !isType('Number',+order)){
            order = this.data.length+1;
          }else{
            order = parseInt(order)+1;
          }
        }
        this.data.push({
          "fid": "",
          "labelOrder": order,
          "labelName": "",
          "remark": "",
          "picUrl":[],
          "link":"",
          "highLight":0,
          "labelType": 5,
          "moduleId": "",
          "isSelect":false
        })
      },
      labellist(){
        if(!this.fid){
          return
        }
        let params={
          moduleFid:this.fid,
          type:5
        }
        labellist(params).then(res=>{
          this.data=res.data
          this.data.forEach(item=>{
            item.isSelect = item.highLight == 1?true:false
          })
        })

      },
      uploadImg(item){
        this.pics = []
        var order = item.labelOrder
        if(!order){
          this.$Message.info('请先添加排序')
          return
        }
        if((+order).toString()==='NaN' || !isType('Number',+order)){
          this.$Message.info('排序字段为数字')
          return
        }
        let labelOrder = this.data.filter(item => item.labelOrder==order)
        if(labelOrder.length > 1 ){
          this.$Message.info('排序字段不能重复')
          return
        }
        if(!item.picUrl){

        }else{
          this.pics = item.picUrl
        }
        this.configFid=item.fid
        this.orderId=order
        this.uploadN++
      },

      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
              labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.labellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        if(this.data.length < 1){
          this.changeLoading()
          this.isShow = false
          return
        }
        let a1=[]
        let isNull=false
        let isnotNumber=false
        let isOverLength=false
        let isPicNull=false

        this.data.forEach(ele=>{
          if(!ele.labelOrder || !ele.remark){
            isNull=true
            return
          }

          if((+ele.labelOrder).toString()==='NaN' || !isType('Number',+ele.labelOrder)){
            isnotNumber=true
            return
          }else{
            if(ele.labelOrder <= 0){
              isnotNumber=true
              return
            }
          }
          a1.push(ele.labelOrder+'')
          if(ele.labelName.length > 10 || ele.remark.length > 200){
            isOverLength = true
            return
          }
          if(!ele.fid && ele.picUrl.length < 1){
            isPicNull = true
            return
          }
          ele.highLight = ele.isSelect?1:0
        })


        if(isPicNull){
          this.$Message.info('图片必传')
          this.changeLoading()
          return
        }

        if(isNull){
          this.$Message.info('请检查必填项')
          this.changeLoading()
          return
        }

        if(isnotNumber){
          this.$Message.info('排序必须为数字,且不能小于等于0')
          this.changeLoading()
          return
        }

        let a2=new Set(a1)
        if(a1.length!== a2.size){
          this.$Message.info('排序不能重复')
          this.changeLoading()
          return
        }
        if(isOverLength){
          this.$Message.info('标签名字数不能超过10个，描述字数不能超过200')
          this.changeLoading()
          return
        }
        let params={
          moduleFid:this.fid,
          labelEntities:this.data,
          proHouseTypeFid:this.projectFid,
          type:1
        }
        labeledit(params).then(res=>{
          this.$Message.success('标签保存成功')
          this.changeLoading()
          this.labellist()
          this.isShow = false
        }).catch(error=>{})
      },
      pic(data){
        if(data.length < 1){
          return
        }
        this.pics = []
        var order = data[0].order
        let labelOrder = this.data.filter(item => {return item.labelOrder==order})
        labelOrder[0].picUrl = []
        data.forEach(item => {
          labelOrder[0].picUrl.push(item)
        })
      }

    },
    created(){
      // this.labellist()
    }

  }
</script>

<style scoped>
  .width80{
    width: 80px;
  }
  .width120{
    width: 120px;
  }
  .width30{
    width: 30px;
  }
  .width50{
    width: 50px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
